const getPurchasingInvoices = ({ page, ...rest }) => ({
  method: "GET",
  url: "/getall_purchasing_invoices",
  data: { ...rest, page: page + 1 },
});

export const purchasingInvoicesApi = {
  getPurchasingInvoices,
};
